var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"toggle-switch-checkbox sr-only",attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.value},on:{"change":_vm.updateInput}}),_c('label',{staticClass:"toggle-switch",attrs:{"for":_vm.id}},[_c('div',{staticClass:"toggle-switch__knob"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }